import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowRight, X } from "lucide-react";
import { Link } from "react-router-dom";

const StickyCtaBar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (~600px)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (dismissed) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 lg:bottom-6 lg:left-auto lg:right-6 lg:w-auto"
        >
          {/* Mobile: full-width bar */}
          <div className="bg-primary border-t border-primary-foreground/10 lg:border lg:rounded-2xl lg:shadow-2xl px-4 py-3 lg:px-6 lg:py-4">
            <div className="flex items-center justify-between gap-3">
              <div className="hidden lg:block">
                <p className="text-primary-foreground text-sm font-semibold">
                  Need monitoring?
                </p>
                <p className="text-primary-foreground/60 text-xs">
                  Free quote — 48h deployment
                </p>
              </div>

              <div className="flex items-center gap-2 flex-1 lg:flex-none">
                <a
                  href="tel:08004647823"
                  className="flex-1 lg:flex-none inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-terracotta-hover transition-colors"
                >
                  <Phone className="w-3.5 h-3.5" />
                  <span className="lg:hidden">Call Now</span>
                  <span className="hidden lg:inline">0800 464 7823</span>
                </a>
                <Link
                  to="/request-quote"
                  className="flex-1 lg:flex-none inline-flex items-center justify-center gap-2 bg-primary-foreground/10 text-primary-foreground px-5 py-2.5 rounded-full text-sm font-medium hover:bg-primary-foreground/20 transition-colors"
                >
                  Get Quote
                  <ArrowRight className="w-3.5 h-3.5" />
                </Link>
                <button
                  onClick={() => setDismissed(true)}
                  className="p-2 text-primary-foreground/40 hover:text-primary-foreground/70 transition-colors"
                  aria-label="Dismiss"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCtaBar;
